import React from "react";
import { PrMrPopupContainer, MrPopupContainer } from "./popupTableHelper";
import ReactDOMServer from "react-dom/server";
import { calculateCumulPluie } from "../../helper";
import { calculRoundValue, getColor, getMeasureValue, getNpValues, getTpValues, Grey } from "./popupHelper";
import { formatDate } from "../view/detailsHelper";
import { PrMrPopupApi, EventsPluieApi, VariablesApi } from "../../api";

export const getInfoPrMr = async (feature) => {
    const attributes = feature.graphic.attributes;
    if (attributes.ModelCode === 'MDI_MR') {
        return getInfoMr(feature);
    }
    let VRefoulementColor = Grey;
    let NbDeversement = 'NR';
    let TDeversement = 'NR';
    let VDeversement = 'NR';
    let VRefoulement = 'NR';
    let VRefoulementCalcule = 'NR';
    let CumulPluie = 'NR';
    let dateRemontee = 'NR';
    let tfctlist;
    let warningLimits = '';
    let dayLimit = false;
    let thousandLimit = false;
    let content = document.createElement('div');
    let returnedTpValues: { tp: string; tpColor: string; pName: any }[] = [];
    let returnedNpValues: { np: string; npColor: string; pName: any }[] = [];

    const categoriesOnly =
        attributes.Color !== 'NOIR' && attributes.Color !== 'GRIS';
    dateRemontee = categoriesOnly
        ? attributes.RecordDate
        : 'Pas de télégestion';

    try {
        const getMearures = categoriesOnly && PrMrPopupApi.getMeasure(attributes.Code, formatDate(attributes.RecordDate));
        const getPluvio = categoriesOnly && PrMrPopupApi.getPluvio(attributes.Code, formatDate(attributes.RecordDate));
        const povInfo = EventsPluieApi.getInstallPov(attributes.Code);
        const [measureData, pluvioData, povValue] = await Promise.allSettled([getMearures, getPluvio, povInfo]);

        let installValue, pluvioValue;
        if (measureData.status === 'fulfilled' && measureData.value) {
            installValue = measureData.value.data;
            if (installValue) {
                tfctlist = installValue.filter((elem) => elem.variableType === 'TFCT');
        
                let nbdemprList = installValue.filter(
                    (elem) => elem.variableType === 'NBDEMPR',
                );
                let newElements: any[] = [];
                tfctlist.forEach((tfct) => {
                    const tfctVariableName = tfct.variableName.slice(1);
                    const matchingNbdempr = nbdemprList.find(
                        (nbdempr) => nbdempr.variableName.slice(1) === tfctVariableName,
                    );
            
                    newElements.push(matchingNbdempr || null);
                });
        
                if (tfctlist.length) {
                    tfctlist.forEach((tfct) => {
                        return getTpValues(tfct, dayLimit, returnedTpValues);
                    });
                }
                if (nbdemprList.length) {
                    newElements.forEach((nbdempr) => {
                        return getNpValues(nbdempr, thousandLimit, returnedNpValues);
                    });
                }
        
                if (thousandLimit && dayLimit) {
                    warningLimits =
                        'Attention : les valeurs 24h et 1 000 affichées sont les valeurs journalières maximales autorisées';
                } else {
                    let limitTypes = '';
                    if (dayLimit) {
                        limitTypes = '24h';
                    } else if (thousandLimit) {
                        limitTypes = '1 000';
                    }
                    if (limitTypes !== '') {
                            warningLimits =
                            'Attention : la valeur ' +
                            limitTypes +
                            ' affichée est la valeur journalière maximale autorisée';
                    }
                }
        
                let tdelist = installValue.filter(
                    (elem) => elem.variableType === 'TDEBPR' || elem.variableType === 'TDEBTP',
                );
                if (tdelist.length) {
                    TDeversement =
                        tdelist[0]?.measure !== null
                        ? Math.round(100 * tdelist[0]?.measure) / 100 + 'h'
                        : 'NR';
                }

                let ndelist = installValue.filter(
                    (elem) => elem.variableType === 'NDEBPR' || elem.variableType === 'NDEBTP',
                );
                if (ndelist[0]) {
                    const calculRound = calculRoundValue(ndelist[0].measure);
                    NbDeversement = getMeasureValue(
                        calculRound,
                        ndelist[0].measure,
                    ).toString();
                }
        
                let vfelist = installValue.filter(
                    (elem) => elem.variableType === 'VPOMPR',
                );
                if (vfelist[0]) {
                // Volume pompé remonté
                const calculRound =
                    vfelist[0].measure !== null
                    ? parseFloat(vfelist[0].measure.toFixed(4))
                    : 'NR';
                VRefoulement = getMeasureValue(
                    calculRound,
                    vfelist[0].measure,
                ).toString();
                VRefoulementColor = getColor(vfelist[0]?.colorLabel);
                // Volume pompé calculé
                const calculRoundPump =
                    vfelist[0].measureCalculate !== null
                    ? parseFloat(vfelist[0].measureCalculate.toFixed(4))
                    : 'NR';
                VRefoulementCalcule = getMeasureValue(
                    calculRoundPump,
                    vfelist[0].measureCalculate,
                ).toString();
                }
                let vdelist = installValue.filter(
                (element) =>
                    element.variableType === 'VDEBPR' ||
                    element.variableType === 'VDEBTP',
                );
                if (vdelist[0]) {
                    VDeversement = vdelist ? vdelist[0]?.measure : 'NR';
                }
            }
        }

        if(pluvioData.status === 'fulfilled' && pluvioData.value) {
            pluvioValue = pluvioData.value.data;
            if (pluvioValue && pluvioValue[0]) {
                CumulPluie = calculateCumulPluie(pluvioValue);
            }
        }

        let idPov = 'NR';
        if (povValue.status === 'fulfilled' && povValue.value) {
            idPov = povValue.value.data;
        }
        
        const TpElements = returnedTpValues.map((val) => [
            val.tpColor,
            val.pName,
            val.tp,
        ]);
        const NpElements = returnedNpValues.map((val) => [
            val.npColor,
            val.pName,
            val.np,
        ]);
        content.innerHTML = ReactDOMServer.renderToString(
            <PrMrPopupContainer
                title={attributes.Description}
                titleValue={dateRemontee}
                tableElements={[
                    TpElements,
                    NpElements.map((val, index) => [
                    val[0],
                    val[1] || returnedTpValues[index].pName,
                    val[2],
                    ]),
                ]}
                elements={[
                    ['Cumul pluie', CumulPluie],
                    ['POV', idPov],
                    ['Temps débordement', TDeversement],
                    ['Nombre débordement', NbDeversement],
                    ['Volume débordé', VDeversement],
                ]}
                dateRemontee={dateRemontee}
                volume={
                    VRefoulement || parseInt(VRefoulement) >= 0
                    ? [VRefoulement, VRefoulementColor, VRefoulementCalcule]
                    : undefined
                }
                warnings={warningLimits}
                pompesSum={tfctlist?.length}
            />
        );
    } catch (error) {
        console.error('Error in getInfoPrMr:', error);
    }
    return content;
};

const getInfoMr = async (feature) => {
    let attributes = feature.graphic.attributes;
    let content = document.createElement('div');
    let categorizationDate = 'NR';
    let diametre = 'NR';
    let hauteur = 'NR';
    let tauxRemplissage = 'NR';
    let volumeJournalier = 'NR';
    let idPov = 'NR';
    let cumulPluie = 'NR';

    const categoriesOnly = attributes.Color !== 'NOIR' && attributes.Color !== 'GRIS';
    const dateRemontee = categoriesOnly ? attributes.RecordDate : 'Pas de télégestion';

    try {
        // Utilise la date de la catégorisation (dateRemontee) : les MR n'ont pas de RecordDate exploitable via télégestion
        const getMeasures = categoriesOnly && PrMrPopupApi.getMeasure(attributes.Code, formatDate(dateRemontee));
        const getPluvio = categoriesOnly && PrMrPopupApi.getPluvio(attributes.Code, formatDate(dateRemontee));
        const povInfo = EventsPluieApi.getInstallPov(attributes.Code);
        const [measureData, pluvioData, povValue] = await Promise.allSettled([getMeasures, getPluvio, povInfo]);

        if (measureData.status === 'fulfilled' && measureData.value) {
            const installValue = measureData.value.data;
            if (installValue) {
                const niveauReseau = installValue.find((elem) => elem.variableType === 'M NIVEAU RESEAU' || elem.variableType === 'M_NIVEAU_RESEAU');
                const volumeReseau = installValue.find((elem) => elem.variableType === 'V RESEAU' || elem.variableType === 'V_RESEAU');

                if (niveauReseau) {
                    hauteur = niveauReseau.measure !== null && niveauReseau.measure !== undefined
                        ? `${niveauReseau.measure} mm`
                        : 'NR';
                    diametre = niveauReseau.diametreCana !== null && niveauReseau.diametreCana !== undefined
                        ? `${niveauReseau.diametreCana} mm`
                        : 'NR';
                    tauxRemplissage = niveauReseau.tauxRemplissage !== null && niveauReseau.tauxRemplissage !== undefined
                        ? `${(niveauReseau.tauxRemplissage*100).toFixed(2)} %`
                        : 'NR';

                    if (niveauReseau.variableId) {
                        const categorization = await VariablesApi.getCategorization(niveauReseau.variableId);
                        const categorizationValue = categorization?.data?.[0]?.categorizationDateTime;
                        if (categorizationValue) {
                            categorizationDate = categorizationValue;
                        }
                    }
                }

                if (volumeReseau) {
                    volumeJournalier = volumeReseau.measure !== null && volumeReseau.measure !== undefined
                        ? `${volumeReseau.measure} m3/j`
                        : 'NR';
                }
            }
        }

        if (pluvioData.status === 'fulfilled' && pluvioData.value) {
            const pluvioValue = pluvioData.value.data;
            if (pluvioValue && pluvioValue[0]) {
                cumulPluie = calculateCumulPluie(pluvioValue);
            }
        }

        if (povValue.status === 'fulfilled' && povValue.value) {
            idPov = povValue.value.data;
        }

        content.innerHTML = ReactDOMServer.renderToString(
            <MrPopupContainer
                title={`${attributes.Code} – ${attributes.Description}`}
                dateRemontee={categorizationDate !== 'NR' ? categorizationDate : dateRemontee}
                elements={{
                    'Diamètre': diametre,
                    'Hauteur': hauteur,
                    'Taux de remplissage': tauxRemplissage,
                    'Volume journalier': volumeJournalier,
                    'POV rattaché': idPov,
                    'Cumul pluie': cumulPluie,
                }}
            />
        );
    } catch (error) {
        console.error('Error in getInfoMr:', error);
    }
    return content;
};